export const columns = [
  {
    Header: 'Customers',
    accessor: 'customers',
    disableSortBy: true,
  },
  {
    Header: 'Project Name',
    accessor: 'name',
  },
  {
    Header: 'Status',
    accessor: 'status',
  },
  {
    Header: 'Actions',
    accessor: 'actions',
    disableGlobalFilter: true,
    disableSortBy: true,
  }
];